<template>
	<div>
		<Head :title="__('KAM')"/>

		<h1 class="mb-8 text-3xl font-bold">{{ __('Key account managers') }}</h1>

		<div class="mb-6 flex items-center justify-between">
			<SearchFilter
				v-model="form.search"
				class="mr-4 w-full max-w-md"
				@reset="reset"
			>
				<label class="mt-4 block text-gray-700">{{ __('Trashed') }}</label>

				<select v-model="form.trashed" class="form-select mt-1 w-full">
					<option :value="null"/>
					<option value="with">{{ __('With Trashed') }}</option>
					<option value="only">{{ __('Only Trashed') }}</option>
				</select>
			</SearchFilter>

			<Link class="btn-cta" href="/kams/create">
				<span>Lägg till</span>
				</Link>
		</div>

		<div class="overflow-x-auto rounded-md bg-white shadow">
			<table class="w-full whitespace-nowrap">
				<tr class="text-left font-bold">
					<th class="px-6 pb-4 pt-6">{{ __('Name') }}</th>
					<th class="px-6 pb-4 pt-6">{{ __('Email') }}</th>
				</tr>

				<tr v-for="kam in kams" :key="kam.id" class="focus-within:bg-gray-100 hover:bg-gray-100">
					<td class="border-t">
						<Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/kams/${kam.id}/edit`">
							<img v-if="kam.photo" class="-my-2 mr-2 block h-5 w-5 rounded-full" :src="kam.photo" :alt="kam.name"/>
							{{ kam.name }}
							<Icon v-if="kam.deleted_at" name="trash" class="ml-2 h-3 w-3 flex-shrink-0 fill-gray-400"/>
						</Link>
					</td>

					<td class="border-t">
						<Link class="flex items-center px-6 py-4" :href="`/kams/${kam.id}/edit`" tabindex="-1">
							{{ kam.email }}
						</Link>
					</td>

					<td class="w-px border-t">
						<Link class="flex items-center px-4" :href="`/kams/${kam.id}/edit`" tabindex="-1">
							<Icon name="cheveron-right" class="block h-6 w-6 fill-gray-400"/>
						</Link>
					</td>
				</tr>

				<tr v-if="kams.length === 0">
					<td class="border-t px-6 py-4" colspan="4">Inga personer hittades</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
	import { Head, Link } from '@inertiajs/inertia-vue3'
	import pickBy 		  from 'lodash/pickBy'
	import Icon 		  from '@/Shared/Icon'
	import Layout 		  from '@/Shared/Layout'
	import throttle 	  from 'lodash/throttle'
	import mapValues 	  from 'lodash/mapValues'
	import SearchFilter   from '@/Shared/SearchFilter'

	export default {
		components: {
			Head,
			Icon,
			Link,
			SearchFilter,
		},
		layout: Layout,
		props: {
			filters: Object,
			kams: [Array, Object],
		},
		data() {
			return {
				form: {
					search: this.filters.search,
					role: this.filters.role,
					trashed: this.filters.trashed,
				}
			}
		},
		watch: {
			form: {
				deep: true,
				handler: throttle(function () {
					this.$inertia.get('/kams', pickBy(this.form), { preserveState: true })
				}, 150),
			},
		},
		methods: {
			reset() {
				this.form = mapValues(this.form, () => null)
			}
		}
	}
</script>
